import { msg } from "@lingui/core/macro";

export const expiryMustBeOnStartDayRuleMessages = {
	name: msg({ message: "Expiry Must Be On Start Day" }),
	description: msg({
		message: "Permit end must fall on the same day as its start when a daily expiry time is configured",
	}),
	errors: {
		crossesDay: msg({ message: "Permit must end before {time} on the same day it starts" }),
		invalidTimeBefore: msg({ message: "Configured expiry time is invalid: {timeBefore}" }),
	},
} as const;
